module.exports = "\n<partial-sidenav></partial-sidenav>\n\n<section id=\"page-container\" class=\"app-page-container\">\n  <partial-header></partial-header>\n\n  <div class=\"app-content-wrapper\">\n    <div class=\"app-content\">\n      <div class=\"full-height\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n\n    <partial-footer></partial-footer>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/layout.component.html
// module id = ../../../../../src/app/layout/layout.component.html
// module chunks = 3